import { useMemo } from 'react';
import { usePropertyValidationRules } from '../hooks/usePropertyValidationRules';
import { AsyncPropertyInputPhoneV2Wrapper, RequirablePropertyInputPhoneWrapper } from '../../input/PropertyInputGetters';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputPhoneShim = props => {
  const {
    loading,
    data: validationRules,
    error
  } = usePropertyValidationRules();
  const phoneNumberValidationRule = useMemo(() => {
    if (error !== undefined || validationRules === undefined) {
      return undefined;
    }
    return validationRules.find(rule => rule.ruleType === 'PHONE_NUMBER_WITH_EXPLICIT_COUNTRY_CODE');
  }, [error, validationRules]);
  if (loading) {
    return null;
  }
  if (phoneNumberValidationRule) {
    return /*#__PURE__*/_jsx(AsyncPropertyInputPhoneV2Wrapper, Object.assign({}, props, {
      defaultCountryCode: phoneNumberValidationRule.ruleArguments.length > 0 ? phoneNumberValidationRule.ruleArguments[0] : undefined
    }));
  }
  return /*#__PURE__*/_jsx(RequirablePropertyInputPhoneWrapper, Object.assign({}, props));
};
export default PropertyInputPhoneShim;